import {useEffect, useState} from 'react';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {AddressUpdate} from './components/AddressUpdate.jsx';
import {CardList} from './components/CardList.jsx';

export const CustomerUpdate = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [token, setToken] = useState('');
  const [updateCode, setUpdateCode] = useState('');
  const [updateType, setUpdateType] = useState('');

  useEffect(() => {
    document.title = 'Fellow Drops - Customer Update';
    if (params.code) {
      fetch('/csrf', {
      }).then(response => {
          setToken(response.headers.get('X-CSRFToken'));
          setUpdateCode(params.code);
          fetch(`/customerupdate?code=${params.code}`, {
          }).then(response => {
            response.json().then(data => {
              if (data.ok) {
                setUpdateType(data.type);
              } else {
                navigate('/');
              }
            });
          });
      });
    } else {
        navigate('/');
    }
  });

  return (
    <div>
      { updateType && updateType == 'Card' &&
        <CardList />
      }
      { updateType && updateType == 'Address' &&
        <AddressUpdate token={token}/>
      }
    </div>
  );
}
